import { GroupBase, OptionsOrGroups, PropsValue } from 'react-select'

import { SelectOptionInterface } from '@customTypes'

import { isGroup } from '../helpers'

function findValues<
  Opt extends SelectOptionInterface,
  Group extends GroupBase<Opt>
>(options: OptionsOrGroups<Opt, Group>, value: Opt['value']) {
  const flattenedOptions = options.reduce<Opt[]>((acc, item) => {
    if (isGroup(item)) {
      return [ ...acc, ...item.options ]
    }

    return [ ...acc, item ]
  }, [] as Opt[])

  return flattenedOptions.find(item =>  item.value === value) as PropsValue<Opt>
}

export function getSelectValue<
  Opt extends SelectOptionInterface,
  Group extends GroupBase<Opt>
>(
  options: OptionsOrGroups<Opt, Group>,
  value?: Opt['value'] | Opt['value'][] | null
): PropsValue<Opt> | undefined {
  if (value !== undefined && value !== null) {
    if (Array.isArray(value)) {
      return value.map(val => findValues(options, val)) as readonly Opt[]
    }

    return findValues(options, value) as PropsValue<Opt>
  }

  return value
}
